// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"db1c9c0c","574":"b696e412","721":"66783759"}[chunkId] + ".chunk.js";
};